import type { StackProps } from '@mui/material';
import { Box, Stack } from '@mui/material';
import { Grid } from './styles';
import type { StorageUnitType } from 'store/storageunits/types';
import Sort from './Sort';
import Text from 'components/Text';

type Props = StackProps & {
  title: string;
  visible: boolean;
  children: React.ReactNode;
  type: StorageUnitType;
  showSorter?: boolean;
};

const StorageUnitsSection = ({
  visible,
  title,
  children,
  type: _type,
  showSorter,
  ...props
}: Props) => {
  if (!visible) {
    return null;
  }

  return (
    <Stack spacing={2} {...props}>
      <Stack
        direction='row'
        sx={{
          width: '100%',
          justifyContent: 'space-between',
          height: 30,
        }}
      >
        <Text size={20} weight='normal'>
          {title}
        </Text>
        {showSorter && (
          <Box
            sx={{
              mr: 2,
            }}
          >
            <Sort />
          </Box>
        )}
      </Stack>
      <Grid>{children}</Grid>
    </Stack>
  );
};

export default StorageUnitsSection;
